export const SPAIN_PHONE_PREFIX_CODE = 'ES';
